import styled from 'styled-components'
import { getFontStyle } from '@diversioteam/diversio-ds'

export const LastUpdated = styled.span`
    color: ${({ theme }) => theme.colors.secondary400};

    ${getFontStyle('p03Regular')}
`

export const Details = styled.span`
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 10px 0;
`

export { ListItemWrapper, ListItemLabel } from './../panel.styles'
